module.exports = __webpack_public_path__ + "static/media/marker_bus_stop_closed.c0561b04.svg";